import { memo } from 'react';
import { LOAN_STATUS_CONFIG, type LoanStatus } from '@/types';

interface StatusBadgeProps {
  status: LoanStatus;
}

export const StatusBadge = memo(function StatusBadge({ status }: StatusBadgeProps) {
  const config = LOAN_STATUS_CONFIG[status];
  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full"
      style={{ color: config.color, backgroundColor: config.bgColor }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: config.color }} />
      {config.label}
    </span>
  );
});
